<template>
  <v-app>
    <v-snackbar v-model="show" :color="color">
      {{ message }}
    </v-snackbar>

    <GlobalLoading />
    
    <router-view />
  </v-app>
</template>

<script setup>
import { toRefs } from 'vue';
import GlobalLoading from '@/components/GlobalLoading.vue';
import { useToastStore } from '@/store/toast';

const toastStore = useToastStore();
const { show, color, message } = toRefs(toastStore);
</script>
<style scoped></style>
